import { useTranslation } from 'react-i18next';
import IntegrationsTable from 'pages/integrations/components/integrationTable/IntegrationsTable';
import { IntegrationCategory } from 'models/InternalIntegrationSetting';
import TabHeader from '../../components/tabHeader/TabHeader';

const IntegrationsCommunicationsTab = () => {
  const { t } = useTranslation();

  return (
    <section>
      <TabHeader tabName={t('pageIntegrations.tabNames.communications')} />
      <IntegrationsTable category={IntegrationCategory.COMMUNICATIONS} />
    </section>
  );
};

export default IntegrationsCommunicationsTab;
